import { NodeErrorConfig } from "@hud/portal-dtos/flow-chart.dtos";

export const showTintingConfig = {
    "minimumInvocationsDay":0,
    "callees": {
      "minimumFunctionErrorRate": 0,
      "sameErrorThreshold": 0.001,
      "everyError": {
        "highThreshold": 0.5,
        "mediumThreshold": 0.1
      }
    },
    "callers": {
      "minimumFunctionErrorRate": 0,
      "highExceptionRate": 0.01,
      "relative": {
        "multiplier": 0,
        "callDistributionThreshold": 0.00,
        "dailyInvocationThreshold": 50
      }
    }
  } satisfies NodeErrorConfig;